export interface Movie {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  type: 'movie' | 'tv';
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'action', name: '动作', icon: 'ri-fire-line' },
  { id: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { id: 'romance', name: '爱情', icon: 'ri-heart-line' },
  { id: 'scifi', name: '科幻', icon: 'ri-rocket-line' },
  { id: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
  { id: 'animation', name: '动画', icon: 'ri-movie-line' },
  { id: 'drama', name: '剧情', icon: 'ri-clapperboard-line' },
  { id: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { id: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'scifi',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20giant%20planetary%20engines%20on%20Earth%20surface%2C%20epic%20scale%2C%20futuristic%20spacecraft%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20Chinese%20characters%20title%20design%2C%20dark%20atmospheric%20background%2C%20movie%20poster%20style%20with%20glowing%20effects&width=600&height=840&seq=tianmei-movie-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀。为了生存，人类倾尽所有，在地球表面建造了一万座行星发动机，推动地球离开太阳系，踏上了长达2500年的宇宙流浪之旅。面对未知的宇宙深处，人类命运将何去何从？',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['科幻巨制', '国产大片', 'IMAX'],
  },
  {
    id: 2,
    title: '满江红',
    category: 'drama',
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20poster%2C%20ancient%20Chinese%20palace%20courtyard%20at%20night%2C%20red%20lanterns%20hanging%2C%20period%20costumes%2C%20mysterious%20atmosphere%2C%20dark%20crimson%20and%20black%20color%20palette%2C%20calligraphy%20title%20design%2C%20cinematic%20lighting&width=600&height=840&seq=tianmei-movie-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中……',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['历史', '悬疑', '喜剧'],
  },
  {
    id: 3,
    title: '哪吒之魔童闹海',
    category: 'animation',
    year: 2026,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20mythological%20child%20warrior%20with%20flaming%20wheels%20and%20red%20sash%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20painting%20style%20with%20modern%20CGI%2C%20vibrant%20red%20and%20gold%20colors%2C%20epic%20sea%20background%20with%20waves&width=600&height=840&seq=tianmei-movie-03&orientation=portrait',
    description: '天劫之后，哪吒、敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身。但是在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩', '绿绮'],
    duration: '144分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['动画', '神话', '国产动画'],
  },
  {
    id: 4,
    title: '封神第二部',
    category: 'action',
    year: 2026,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20war%20movie%20poster%2C%20ancient%20warriors%20in%20armor%20riding%20horses%20into%20battle%2C%20massive%20army%20formation%2C%20dramatic%20sky%20with%20fire%20and%20smoke%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20fantasy%20style&width=600&height=840&seq=tianmei-movie-04&orientation=portrait',
    description: '殷商大军兵临西岐，姜子牙与姬发率领西岐军民奋力抵抗。闻仲率邓婵玉、魔家四将等殷商大将进攻西岐，一场封神大战就此拉开序幕。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    duration: '148分钟',
    type: 'movie',
    isHot: true,
    isNew: true,
    tags: ['神话', '战争', '史诗'],
  },
  {
    id: 5,
    title: '孤注一掷2',
    category: 'suspense',
    year: 2026,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20dark%20computer%20room%20filled%20with%20monitors%2C%20shadowy%20figures%2C%20dramatic%20red%20neon%20lighting%2C%20suspenseful%20atmosphere%2C%20Chinese%20urban%20setting%2C%20cyber%20crime%20theme%2C%20gritty%20cinematic%20look&width=600&height=840&seq=tianmei-movie-05&orientation=portrait',
    description: '程序天才潘生被高薪招聘吸引出国，却落入境外诈骗工厂的陷阱。为了离开，潘生与同样被骗的模特安娜合作，准备在诈骗集团内部完成一场惊天逆转……',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    duration: '130分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['犯罪', '悬疑', '现实主义'],
  },
  {
    id: 6,
    title: '唐人街探案4',
    category: 'comedy',
    year: 2026,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%20set%20in%20London%2C%20two%20Chinese%20detectives%20in%20trench%20coats%2C%20Big%20Ben%20in%20background%2C%20colorful%20neon%20signs%2C%20playful%20mystery%20theme%2C%20bright%20and%20vibrant%20color%20palette%2C%20detective%20film%20noir%20style&width=600&height=840&seq=tianmei-movie-06&orientation=portrait',
    description: '唐仁和秦风受邀来到伦敦，调查一起连环失踪案。在异国他乡，他们不仅面临复杂的案件，还要应对各种文化冲突和意想不到的挑战。',
    director: '陈思诚',
    actors: ['王宝强', '刘昊然', '肖央', '张子枫'],
    duration: '136分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '悬疑', '动作'],
  },
  {
    id: 7,
    title: '长津湖之水门桥',
    category: 'action',
    year: 2025,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20Chinese%20soldiers%20in%20winter%20battle%20gear%2C%20snowy%20mountain%20landscape%2C%20intense%20battle%20scene%2C%20cold%20blue%20and%20white%20color%20palette%2C%20heroic%20pose%2C%20cinematic%20war%20drama%20style&width=600&height=840&seq=tianmei-movie-07&orientation=portrait',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务——炸毁水门桥。',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文', '李晨'],
    duration: '149分钟',
    type: 'movie',
    isHot: true,
    isNew: false,
    tags: ['战争', '历史', '主旋律'],
  },
  {
    id: 8,
    title: '繁花',
    category: 'drama',
    year: 2025,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20night%20street%20scene%2C%20neon%20lights%2C%20elegant%20woman%20in%20cheongsam%2C%20retro%20aesthetic%2C%20golden%20and%20warm%20tones%2C%20nostalgic%20atmosphere&width=600&height=840&seq=tianmei-movie-08&orientation=portrait',
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上，人人都在争一口气，人人都想成为那个"宝总"。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    duration: '30集',
    type: 'tv',
    isHot: true,
    isNew: false,
    tags: ['年代剧', '商战', '爱情'],
  },
  {
    id: 9,
    title: '三体·黑暗森林',
    category: 'scifi',
    year: 2026,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20cosmic%20dark%20forest%20concept%2C%20starry%20universe%20background%2C%20mysterious%20alien%20civilization%20signal%2C%20dark%20and%20cold%20space%20atmosphere%2C%20philosophical%20sci-fi%20aesthetic%2C%20deep%20space%20visuals&width=600&height=840&seq=tianmei-movie-09&orientation=portrait',
    description: '三体人在利用魔法般的科技锁死了地球人的科学之后，庞大的宇宙舰队开始向地球进发。人类在危机面前也组建起庞大的太空舰队，同时制定了神秘的"面壁计划"。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '30集',
    type: 'tv',
    isHot: true,
    isNew: true,
    tags: ['科幻', '悬疑', '国产科幻'],
  },
  {
    id: 10,
    title: '你好，李焕英2',
    category: 'comedy',
    year: 2026,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20comedy%20movie%20poster%2C%20mother%20and%20daughter%20embracing%20in%201980s%20Chinese%20factory%20setting%2C%20warm%20sunlight%2C%20nostalgic%20retro%20color%20palette%2C%20emotional%20and%20sweet%20atmosphere%2C%20vintage%20photography%20style&width=600&height=840&seq=tianmei-movie-10&orientation=portrait',
    description: '贾晓玲意外穿越回到了1981年，与年轻时的母亲李焕英相遇。在这个陌生的年代，贾晓玲决定改变母亲的命运，让她过上更好的生活。',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾', '陈赫'],
    duration: '128分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '亲情', '穿越'],
  },
  {
    id: 11,
    title: '异形·夺命舰',
    category: 'horror',
    year: 2026,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20horror%20movie%20poster%20with%20alien%20creature%20silhouette%20in%20dark%20spaceship%20corridor%2C%20bio-mechanical%20design%2C%20green%20glowing%20accents%2C%20claustrophobic%20atmosphere%2C%20dark%20and%20terrifying%20tone%2C%20space%20horror%20theme&width=600&height=840&seq=tianmei-movie-11&orientation=portrait',
    description: '一群年轻的太空殖民者在一座废弃的空间站深处，发现了一种神秘而可怕的外星生物。面对这种完美的猎杀者，他们必须为了生存而战斗。',
    director: '费德·阿尔瓦雷兹',
    actors: ['卡莉·史派妮', '伊莎贝拉·默塞德', '吴彦祖'],
    duration: '119分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['恐怖', '科幻', '外星生物'],
  },
  {
    id: 12,
    title: '庆余年第二季',
    category: 'drama',
    year: 2026,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20TV%20series%20poster%2C%20handsome%20scholar%20in%20ancient%20Chinese%20robe%2C%20palace%20intrigue%20theme%2C%20golden%20and%20jade%20color%20palette%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20dramatic%20lighting&width=600&height=840&seq=tianmei-movie-12&orientation=portrait',
    description: '范闲经历了生死考验后返回京都，借助监察院的强大力量和各方势力的支持，开始追查母亲叶轻眉之死的真相，同时努力实现自己改变世界的理想。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '36集',
    type: 'tv',
    isHot: true,
    isNew: true,
    tags: ['权谋', '古装', '奇幻'],
  },
  {
    id: 13,
    title: '消失的她2',
    category: 'suspense',
    year: 2026,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20woman%20disappearing%20into%20shadows%2C%20tropical%20island%20resort%20setting%2C%20dark%20ocean%20background%2C%20mysterious%20atmosphere%2C%20green%20and%20teal%20color%20palette%2C%20suspenseful%20cinematic%20style&width=600&height=840&seq=tianmei-movie-13&orientation=portrait',
    description: '在东南亚某度假海岛，一名男子报案妻子失踪，然而当妻子"回来"后，他却坚称眼前的女人不是自己的妻子。真相与谎言交织，一场惊心动魄的博弈就此展开。',
    director: '陈思诚',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '122分钟',
    type: 'movie',
    isHot: false,
    isNew: true,
    tags: ['悬疑', '犯罪', '反转'],
  },
  {
    id: 14,
    title: '芭比',
    category: 'comedy',
    year: 2023,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Fantasy%20comedy%20movie%20poster%20with%20pink%20aesthetic%2C%20Barbie%20doll%20world%20theme%2C%20pastel%20color%20palette%2C%20whimsical%20and%20vibrant%20style%2C%20dreamy%20fantasy%20setting%2C%20fashion%20and%20fun%20vibe&width=600&height=840&seq=tianmei-movie-14&orientation=portrait',
    description: '在芭比乐园里，各种各样的芭比和肯每天都过着童话般完美的生活。但是某一天，芭比发现自己的生活开始有了变化，她必须前往真实世界探寻真相。',
    director: '格蕾塔·葛韦格',
    actors: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉'],
    duration: '114分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '奇幻', '女性'],
  },
  {
    id: 15,
    title: '熊出没·逆转时空',
    category: 'animation',
    year: 2026,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20two%20bears%20and%20a%20logger%20character%2C%20time%20travel%20theme%20with%20clock%20elements%2C%20colorful%20forest%20background%2C%20fun%20and%20adventurous%20vibe%2C%20bright%20and%20cheerful%20colors&width=600&height=840&seq=tianmei-movie-15&orientation=portrait',
    description: '光头强与熊大熊二意外获得了一台可以让时光倒流的机器。他们决定利用这台机器回到过去，弥补各自的遗憾，却引发了一连串意想不到的混乱。',
    director: '林汇达',
    actors: ['光头强', '熊大', '熊二', '吉吉国王'],
    duration: '99分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['动画', '喜剧', '家庭'],
  },
  {
    id: 16,
    title: '独行月球',
    category: 'scifi',
    year: 2025,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20movie%20poster%20with%20astronaut%20alone%20on%20moon%20surface%2C%20Earth%20visible%20in%20background%2C%20lonely%20and%20humorous%20tone%2C%20starry%20space%20background%2C%20silver%20spacesuit%2C%20cinematic%20space%20comedy%20style&width=600&height=840&seq=tianmei-movie-16&orientation=portrait',
    description: '人类为阻止小行星撞击地球，部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人落在了月球。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦', '常远'],
    duration: '122分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['科幻', '喜剧', '太空'],
  },
  {
    id: 17,
    title: '我的阿勒泰',
    category: 'drama',
    year: 2026,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20drama%20poster%20with%20vast%20grassland%20and%20mountains%2C%20young%20woman%20in%20traditional%20Kazakh%20costume%2C%20golden%20sunset%20light%2C%20nomadic%20lifestyle%20theme%2C%20warm%20and%20natural%20tones%2C%20cinematic%20pastoral%20aesthetic&width=600&height=840&seq=tianmei-movie-17&orientation=portrait',
    description: '生长在城市的汉族少女李文秀，来到新疆阿勒泰地区与母亲相依为命。在这片广袤的土地上，她结识了哈萨克族少年巴太，经历了一段难忘的青春岁月。',
    director: '腾丛丛',
    actors: ['马伊琍', '周依然', '于适', '蒋奇明'],
    duration: '8集',
    type: 'tv',
    isHot: false,
    isNew: true,
    tags: ['文艺', '青春', '自然'],
  },
  {
    id: 18,
    title: '志愿军·雄兵出击',
    category: 'action',
    year: 2025,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20epic%20movie%20poster%20with%20soldiers%20charging%20into%20battle%2C%20explosions%20and%20smoke%2C%20heroic%20determination%2C%20dark%20and%20intense%20atmosphere%2C%20large%20scale%20battle%20scene%2C%20patriotic%20theme&width=600&height=840&seq=tianmei-movie-18&orientation=portrait',
    description: '1949年建国初期，新中国面临"内忧外患"局面。为了维护来之不易的和平、为了世代长久的安稳，中国人民志愿军入朝作战。这是一场关乎国运的战争。',
    director: '陈凯歌',
    actors: ['唐国强', '王砚辉', '刘劲', '辛柏青'],
    duration: '140分钟',
    type: 'movie',
    isHot: false,
    isNew: false,
    tags: ['战争', '历史', '爱国主义'],
  },
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);

export function getMoviesByCategory(category: string): Movie[] {
  if (category === 'all') return movies;
  return movies.filter(m => m.category === category);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(movie: Movie, count: number = 6): Movie[] {
  return movies
    .filter(m => m.id !== movie.id && m.category === movie.category)
    .slice(0, count);
}